import { merge, throttle } from 'lodash';
import { AppState } from 'types';
import { LoadingState } from 'store/state';
import json from '../../package.json';

const LOCAL_STORAGE_NAMESPACE = 'ARION_NAMESPACE';

console.info(`${json.name} version: ${json.version}`);

export const saveState = throttle((state: AppState) => {
	window.localStorage.setItem(
		LOCAL_STORAGE_NAMESPACE,
		JSON.stringify({
			...state,
			loading: LoadingState(0)
		})
	);
}, 900);

export function loadState(defaultState: AppState): AppState {
	const state = window.localStorage.getItem(LOCAL_STORAGE_NAMESPACE);

	if (state) {
		const parsed = JSON.parse(state);
		if (parsed && json.version === parsed?.version) {
			return merge(defaultState, parsed);
		} else {
			saveState(defaultState);
		}
	}

	return defaultState;
}
